import React, {Component} from 'react';
import {connect} from 'react-redux';
import Console from './Console/Console';
import cssClasses from './Consoles.css'
import {Row, Col} from 'react-bootstrap';
import MidSettings from '../MidSettings/MidSettings'
import * as actionCreators from '../../store/actions/index'

import ConsoleControls from './ConsoleControls/ConsoleControls';
import MainPanner from '../MainPanner/MainPanner';
import Spinner from '../UI/Spinner/Spinner';
import Backdrop from '../UI/Backdrop/Backdrop';

const consoleLeftStyle = {
    songName: {
        className: "text-left"
    },
    songDuration: {
        className: "text-right"
    },
    artistInfo: {
        className: "text-left"
    }
}
const consoleRightStyle = {
    flex: {
        flexDirection: "row-reverse"
    },
    songName: {
        className: "text-right"
    },
    songDuration: {
        className: "text-left"
    },
    artistInfo: {
        className: "text-right"
    }
}

class Consoles extends Component {

    constructor(props) {
        super(props);
        this.props.audios[0].audioRef = React.createRef();
        this.props.audios[1].audioRef = React.createRef();

        if (this.props.effects && this.props.effects.length > 0) {
            this.props.effects.map((effect, index) => this.props.effects[index].effectRef = React.createRef());
        }
    }

    componentDidMount() {
        this.props.onInitAudios(this.props.audios, this.props.effects);
    }


    render() {
        const soundEffectsSetOne = this.props.effects && this.props.effects.length > 0 ? this.props.effects.slice(0, 4) : [];
        const soundEffectsSetTwo = this.props.effects && this.props.effects.length > 0 ? this.props.effects.slice(4, 8) : [];
        const loadingBackDrop = this.props.loading ? (
            <Backdrop show><Spinner/></Backdrop>
        ) : null;


        return (
            <React.Fragment>
                {loadingBackDrop}
                <Row className={cssClasses.Consoles}>
                    <Col md={5} sm={12} className={cssClasses.ConsoleColumn}>
                        <Console
                            specialStyling={consoleLeftStyle}
                            id={this.props.audios[0].id}
                        />
                    </Col>
                    <Col md={2} sm={12} className={cssClasses.SettingColumn}>
                        <MidSettings/>
                    </Col>
                    <Col md={5} sm={12} className={cssClasses.ConsoleColumn}>
                        <Console
                            specialStyling={window.innerWidth > 768 ? consoleRightStyle : consoleLeftStyle}
                            id={this.props.audios[1].id}
                        />
                    </Col>
                </Row>
                <Row className={cssClasses.ConsoleControl}>
                    <Col md={4} sm={12} xs={12} className={cssClasses.ConsolesCol}>
                        <ConsoleControls
                            style={{float: "right"}}
                            soundEffects={soundEffectsSetOne}
                            onPlayEffect={this.props.onPlayEffect}
                        />
                    </Col>
                    <Col md={4} sm={12} xs={12} className={cssClasses.ConsolesCol}>
                        <MainPanner value={this.props.mainPannerValue}
                                    valueChange={this.props.onPannerChangeHandler}/>
                    </Col>
                    <Col md={4} sm={12} xs={12} className={cssClasses.ConsolesCol}>
                        <ConsoleControls
                            style={{float: "left"}}
                            soundEffects={soundEffectsSetTwo}
                            onPlayEffect={this.props.onPlayEffect}
                        />
                    </Col>
                </Row>
            </React.Fragment>

        );
    }

}

const mapStateToProps = state => {
    return {
        audios: state.audios,
        mainPannerValue: state.mainPannerValue,
        loading: state.loading,
        effects: state.effects
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onInitAudios: (audios, effects) => dispatch(actionCreators.initAudios(audios, effects)),
        onPannerChangeHandler: (value) => dispatch(actionCreators.pannerChangeHandler(value)),
        onPlayEffect: (effectIndex) => dispatch(actionCreators.onPlayEffect(effectIndex))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Consoles);